import { useQuery } from "@tanstack/react-query";
import { AXIOS_RESERVATION } from "../utils/axios-interceptors";
import { IUseGetCategoriesQueryResponse } from "../utils/types";
import { isStaging } from "../utils/helpers";

const useGetCategoriesQuery = (): IUseGetCategoriesQueryResponse =>
  useQuery({
    queryKey: ["categories"],
    queryFn: async (data) => {
      const response = await AXIOS_RESERVATION.get(
        isStaging ? "android-tv-home" : "getAndroidTVHome",
        data
      );
      return response.data;
    },
  });

export default useGetCategoriesQuery;
